<template>
    <footer class="footer py-4">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-4 text-lg-start">
                        Citas En Morelos: <a class="link-dark text-decoration-none me-3" 
                        href="tel:527772855103" id="contact"> 7772855103</a>                        
                    </div>
                    <div class="col-lg-4 my-3 my-lg-0">
                        <a class="btn btn-primary btn-social mx-2" 
                        href="https://www.linkedin.com/in/carlos-barocio-66972235b"
                        target="_blank"
                         aria-label="LinkedIn">
                            <i class="fab fa-linkedin-in"></i></a>                        
                        <a class="btn btn-primary btn-social mx-2" 
                        href="https://www.instagram.com/barocio_asocia2/" 
                        target="_blank"
                        aria-label="Instagram">
                            <i class="fab fa-instagram"></i>
                        </a>                        
                        <a class="btn btn-primary btn-social mx-2" 
                        href="https://www.facebook.com/barocio.asociados" 
                        target="_blank"
                        aria-label="Facebook"><i class="fab fa-facebook-f"></i></a>                        
                        <a class="btn btn-primary btn-social mx-2" 
                        href="https://x.com/BAROCIOASOCIA2" 
                        target="_blank"
                        aria-label="Twitter">
                            <i class="fab fa-twitter"></i></a>
                        <a class="btn btn-primary btn-social mx-2" 
                        href="https://www.youtube.com/@BAROCIOyASOCIADOS" 
                        target="_blank"
                        aria-label="Canal de Temas Legales">
                            <i class="fab fa-youtube"></i>
                        </a>
                    </div>
                    <div class="col-lg-4 text-lg-end">
                        Powered by &copy; <a href="https://tecweb.pages.dev" _target="_blank" 
                        class="link-dark text-decoration-none" title="Desarrollo de Sitios Web">TecWeb</a> 2025                        
                    </div>
                </div>
            </div>
        </footer>
</template>